"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusSelected = exports.prevFocus = exports.nextFocus = void 0;

// import filterOptions from './filterOptions';
var nextFocus = function nextFocus(options, focused) {
  if (Number.isNaN(focused)) {
    return options.findIndex(function (val) {
      return !val.disabled;
    });
  }

  for (var i = focused + 1; i < options.length; i += 1) {
    if (!options[i].disabled) return i;
  }

  return focused;
};

exports.nextFocus = nextFocus;

var prevFocus = function prevFocus(options, focused) {
  if (Number.isNaN(focused)) {
    return options.findIndex(function (val) {
      return !val.disabled;
    });
  }

  for (var i = focused - 1; i >= 0; i -= 1) {
    if (!options[i].disabled) return i;
  }

  return focused;
};

exports.prevFocus = prevFocus;

var focusSelected = function focusSelected(selectedOption, options) {
  var selectedIndex = selectedOption ? options.findIndex(function (_ref) {
    var value = _ref.value;
    return value === selectedOption.value;
  }) : -1;
  if (selectedIndex !== -1) return selectedIndex;
  return nextFocus(options, -1, '');
};

exports.focusSelected = focusSelected;